<template>
    <div class="w-full">
        <p class="text-center font-weight-bolder mt-1 mb-2">About your company</p>
        <p class="text-center mb-3">Upload your logo</p>
        <div class="flex flex-column w-full items-center justify-center text-center">
            <div class="w-full p-12 bg-gray-100 border border-gray-300" :class="{'is-invalid custom-border-red': hasError('logo')}" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                <input type="file" name="fields[assetsFieldHandle][]" id="assetsFieldHandle"
                       class="w-px h-px opacity-0 overflow-hidden absolute" @change="onChange" ref="file" accept=".jpg,.jpeg,.png" />


                <ul class="p-0" v-if="fileList.length > 0" v-cloak>
                    <li class="text-sm p-1" v-for="(file, key) in fileList">
                        <div class="file-listing">
                            <img class="preview" v-bind:ref="'preview'+parseInt( key )"/>
                        </div>
                        {{ file.name }}
                        <button class="ml-2" type="button" @click="remove(fileList.indexOf(file))" title="Remove file">
                            <i class="fa fa-btn fa-close" style="color: red"></i>
                        </button>
                    </li>
                </ul>
                <label v-else for="assetsFieldHandle" class="block cursor-pointer">
                    <span>
                        <img style='width:45%; margin-bottom:5px' src='https://prod-followupcrm.s3.us-east-2.amazonaws.com/signup-images/upload-icon.png'>
                    </span><br>
                    <span class='btn btn-primary' style='margin-bottom:5px'>Choose logo</span>
                    <br>Or drag and drop
                </label>
            </div>
            <span class="invalid-feedback text-left" v-show="hasError('logo')">{{ getError('logo') }}</span>
        </div>

        <div class="form-group mt-3">
            <select name="company_industry" id="company_industry" style="background-color: #ebebeb" v-model="form.selected_company_industry"
                    :class="{'is-invalid custom-border-red': hasError('selected_company_industry')}" @change="removeError('selected_company_industry')"
                    class="w-full py-2 px-2 leading-normal text-grey-darkest text-sm focus:outline-none border-1">
                <option value="" selected disabled>Company Industry</option>
                <option v-for="option in options.company_industries" v-bind:value="option.value">
                    {{ option.text }}
                </option>
            </select>
            <span class="invalid-feedback" v-show="hasError('selected_company_industry')">{{ getError('selected_company_industry') }}</span>
        </div>

        <div class="form-group">
            <select style="background-color: #ebebeb" v-model="form.selected_user" :class="{'is-invalid custom-border-red': hasError('selected_user')}" @change="removeError('selected_user')"
                    class="w-full py-2 px-2 leading-normal text-grey-darkest text-sm focus:outline-none border-1">
                <option value="" selected disabled>About how many users will use the CRM?</option>
                <option v-for="option in options.users" v-bind:value="option.value">
                    {{ option.text }}
                </option>
            </select>
            <span class="invalid-feedback" v-show="hasError('selected_user')">{{ getError('selected_user') }}</span>
        </div>

        <div class="col-md-12" style="display: flex; align-items: center; justify-content: center">
            <button class="mr-3 mt-3 btn-secondary py-3 px-4 text-white hover:text-white focus:outline-none"
                    style="border-radius: 10px; box-shadow: rgb(160 160 160) 1px 3px 8px 1px;" type="button" id="firstNext" @click="goToStepOne()">Back
            </button>
            <button @click="next()" class="mr-3 mt-3 btn-primary py-3 px-4 text-white hover:text-white focus:outline-none"
                    style="border-radius: 10px; box-shadow: rgb(160 160 160) 1px 3px 8px 1px;" type="button" id="secondNext">Next</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "form-two",
    delimiters: ['${', '}'],
    data() {
        return {
            fileList:[],
            options:{
                users:[
                    { text: '1-5', value: '5' },
                    { text: '5-10', value: '10' },
                    { text: '10-20', value: '20' },
                    { text: '20+', value: '21' }
                ],
                company_industries:[
                    { text: 'Roofing', value: 'Roofing' },
                    { text: 'Concrete', value: 'GLASS_CERAMICS_CONCRETE' },
                    { text: 'GC', value: 'GC' },
                    { text: 'Electrical', value: 'ELECTRICAL_ELECTRONIC_MANUFACTURING' },
                    { text: 'Commercial', value: 'COMMERCIAL_REAL_ESTATE' },
                    { text: 'Interior', value: 'Interior' },
                    { text: 'Drywall', value: 'Drywall' },
                    { text: 'Other', value: 'Other' }
                ]
            },
            form: {
                logo: null,
                selected_company_industry: "",
                selected_user: "",
            },
            errors: [],
        }
    },
    methods:{
        next: function (){
            const self = this;
            const isValid = self.checkForm();

            console.log("isValid" , isValid)
            if(!isValid) {
                console.log("inside");
                self.form.logo = this.fileList;
                let data = {
                    formNumber: 'two',
                    formData:self.form
                }
                Bus.$emit('changeForm', 'three');
                Bus.$emit('updateFormData', data);
            }
        },
        checkForm: function () {
            this.errors = [];

            if (this.form.selected_company_industry === null || this.form.selected_company_industry === '') {
                this.errors['selected_company_industry'] = "Company Industry is required.";
            }
            // if (this.fileList.length === 0) {
            //     this.errors['logo'] = "Company Logo is required.";
            // }
            if (this.form.selected_user === null || this.form.selected_user === '') {
                this.errors['selected_user'] = "This field is required";
            }

            console.log(this.errors)
            for (const key in this.errors){
                if(!!key){
                    return true
                }
            }
            return false
        },
        onChange() {
            this.fileList = [...this.$refs.file.files];
            this.getImagePreviews();
            this.removeError('logo');
        },
        remove(i) {
            this.fileList.splice(i, 1);
            this.$refs.file.value = ''; // Clear the input value
        },
        dragover(event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains('bg-green-300')) {
                event.currentTarget.classList.remove('bg-gray-100');
                event.currentTarget.classList.add('bg-green-300');
            }
        },
        dragleave(event) {
            // Clean up
            event.currentTarget.classList.add('bg-gray-100');
            event.currentTarget.classList.remove('bg-green-300');
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange(); // Trigger the onChange event manually
            // Clean up
            event.currentTarget.classList.add('bg-gray-100');
            event.currentTarget.classList.remove('bg-green-300');
        },
        getImagePreviews(){
            /*
              Iterate over all of the files and generate an image preview for each one.
            */
            for( let i = 0; i < this.fileList.length; i++ ){
                /*
                  Ensure the file is an image file
                */
                if ( /\.(jpe?g|png|gif)$/i.test( this.fileList[i].name ) ) {
                    /*
                      Create a new FileReader object
                    */
                    let reader = new FileReader();

                    /*
                      Add an event listener for when the file has been loaded
                      to update the src on the file preview.
                    */
                    reader.addEventListener("load", function(){
                        this.$refs['preview'+parseInt( i )][0].src = reader.result;
                    }.bind(this), false);

                    /*
                      Read the data for the file in through the reader. When it has
                      been loaded, we listen to the event propagated and set the image
                      src to what was loaded from the reader.
                    */
                    reader.readAsDataURL( this.fileList[i] );
                }else{
                    /*
                      We do the next tick so the reference is bound and we can access it.
                    */
                    this.$nextTick(function(){
                        this.$refs['preview'+parseInt( i )][0].src = '/images/file.png';
                    });
                }
            }
        },
        hasError: function (field) {
            return _.indexOf(_.keys(this.errors), field) > -1;
        },
        removeError : function (field) {
            const self = this
            if (self.hasError(field)) {
                delete self.errors[field]
            }
        },
        getError : function (field) {
            const self = this;
            if (self.hasError(field)) {
                return self.errors[field];
            }
        },
        goToStepOne() {
            Bus.$emit('changeForm', 'one')
        }
    }
}
</script>

<style>
[v-cloak] {
    display: none;
}

div.file-listing{
    width: 220px;
    margin: auto;
    padding: 10px;
    border-bottom: 1px solid #ddd;
}

div.file-listing img{
    height: 200px;
}
.custom-border-red {
    border-color: #dc3545 !important;
}
</style>
